import * as React from "react";
import { WebPortalClient } from "webportalclient";
import { ODataParams, Query } from "../../Components/Query";
import DocumentTitle from "../../misc/components/DocumentTitle";
import { ServiceResourcesTable } from "./ServiceResourcesTable";
import { useCurrentStudyConfigurationContext } from "../../Core/CurrentStudyConfigurationContext";
import { useWebPortalApiClient } from "../../misc/api/WebPortalTokenClient";

export const ServiceResourcesList = () => {
    const client = useWebPortalApiClient();
    const { study } = useCurrentStudyConfigurationContext();

    const handleRefresh = async (params: ODataParams) => {

        let filter = params.filter ? `(${params.filter})` : '';
        filter += `studyId eq ${study.id}`;

        return await client.client.getServiceResources(undefined, filter, params.orderby, undefined, params.top, params.skip, undefined, true);
    };

    return (
        <DocumentTitle title="Service Resources | Vitalograph Web Portal">
            <Query onRefresh={handleRefresh} initialOrdering={[{ field: "name", condition: "asc" }]}>
                <ServiceResourcesTable />
            </Query>
        </DocumentTitle>
    );
}
